export default __webpack_public_path__ + "static/media/logotech.7703d2fe.png";